function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("circle", {
  id: "path-1",
  cx: 19,
  cy: 19,
  r: 19
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "UID",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Customers1-2-Search",
  transform: "translate(-1243.000000, -13.000000)"
}, React.createElement("g", {
  id: "Top-nav",
  transform: "translate(210.000000, 0.000000)"
}, React.createElement("g", {
  id: "Account",
  transform: "translate(1033.000000, 13.000000)"
}, React.createElement("g", {
  id: "img-profile-placeholder-S"
}, React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-1"
})), React.createElement("use", {
  id: "profile-base",
  fill: "#E1E4E8",
  xlinkHref: "#path-1"
}), React.createElement("path", {
  d: "M18.8333333,26 C22.9744376,26 26.3333333,22.6359447 26.3333333,18.4884793 C26.3333333,14.3410138 22.9744376,11 18.8333333,11 C14.692229,11 11.3333333,14.3640553 11.3333333,18.4884793 C11.3333333,22.6129032 14.692229,26 18.8333333,26 L18.8333333,26 Z M31.3263364,37.6666667 C31.3287265,37.6888649 31.3310589,37.7110872 31.3333333,37.7333333 L7.33333333,37.7333333 C7.33562214,37.7110883 7.33796964,37.6888659 7.34037561,37.6666667 C6.501504,37.6666667 5.98850575,37.6666667 5.98850575,37.6666667 C5.43678161,37.6666667 5,37.2323009 5,36.6836283 C5,31.5169617 9.22988506,27.3333333 14.4022989,27.3333333 L23.5977011,27.3333333 C28.7931034,27.3333333 33,31.539823 33,36.6836283 C33,37.2323009 32.5632184,37.6666667 32.0114943,37.6666667 C32.0114943,37.6666667 31.7619481,37.6666667 31.326345,37.6666667 Z M19,13.3333333 C21.9333333,13.3333333 24.3333333,15.7333333 24.3333333,18.6666667 C24.3333333,21.6 21.9333333,24 19,24 C16.0666667,24 13.6666667,21.6 13.6666667,18.6666667 C13.6666667,15.7333333 16.0666667,13.3333333 19,13.3333333 Z M31.3263364,37.6666667 C30.8194605,32.9590592 27.7155711,29.3333333 23.9487179,29.3333333 L14.7179487,29.3333333 C10.9512079,29.3333333 7.84739122,32.9885603 7.34037561,37.6666667 C9.95097138,37.6666667 15.7175764,37.6666667 19,37.6666667 C22.601528,37.6666667 29.1937205,37.6666667 31.326345,37.6666667 Z",
  id: "profile",
  fill: "#FFFFFF",
  mask: "url(#mask-2)"
}))))));

var SvgImgProfilePlaceholderS = function SvgImgProfilePlaceholderS(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "38px",
    height: "38px",
    viewBox: "0 0 38 38",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgImgProfilePlaceholderS, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/img-profile-placeholder-S.12642fe4.svg";
export { ForwardRef as ReactComponent };